// Preserve the designer's DI endpoints while giving diagonal segments a right-angle route.
// Legacy diagrams without DI continue through the viewer unchanged.
export const orthogonalRuntimeDiagram = (xml: string): string => {
    if (!xml.includes("BPMNEdge") || !xml.includes("waypoint")) return xml;
    const document = new DOMParser().parseFromString(xml, "application/xml");
    if (document.getElementsByTagName("parsererror").length) return xml;
    const edges = Array.from(document.getElementsByTagNameNS("http://www.omg.org/spec/BPMN/20100524/DI", "BPMNEdge"));
    let changed = false;
    edges.forEach((edge) => {
        const points = Array.from(edge.getElementsByTagNameNS("http://www.omg.org/spec/DD/20100524/DI", "waypoint"));
        for (let index = points.length - 2; index >= 0; index -= 1) {
            const source = points[index];
            const target = points[index + 1];
            const x1 = Number(source.getAttribute("x"));
            const y1 = Number(source.getAttribute("y"));
            const x2 = Number(target.getAttribute("x"));
            const y2 = Number(target.getAttribute("y"));
            if (![x1, y1, x2, y2].every(Number.isFinite) || x1 === x2 || y1 === y2) continue;
            const middleX = (x1 + x2) / 2;
            const first = document.createElementNS("http://www.omg.org/spec/DD/20100524/DI", "di:waypoint");
            first.setAttribute("x", String(middleX));
            first.setAttribute("y", String(y1));
            const second = document.createElementNS("http://www.omg.org/spec/DD/20100524/DI", "di:waypoint");
            second.setAttribute("x", String(middleX));
            second.setAttribute("y", String(y2));
            edge.insertBefore(first, target);
            edge.insertBefore(second, target);
            changed = true;
        }
    });
    return changed ? new XMLSerializer().serializeToString(document) : xml;
};
